<div class="flex column">
  @for (brand of menu; track brand.key) {
    <div class="flex center hover bold uppercase padding-top-smallest padding-bottom-smallest" (click)="toggleNode(brand.key)">
      <i class="fa-solid {{ isOpen(brand.key) ? 'fa-angle-down' : 'fa-angle-right' }} small grey margin-right-small"></i>
      {{ brand.label }}
    </div>

    @if (isOpen(brand.key)) {
      @for (collection of brand.collections; track collection.key) {
        <div class="flex center hover padding-top-smallest padding-bottom-smallest padding-left-small" (click)="toggleNode(collection.key)">
          <i class="fa-solid {{ isOpen(collection.key) ? 'fa-angle-down' : 'fa-angle-right' }} small grey margin-right-small"></i>
          {{ collection.label }}
        </div>

        @if (isOpen(collection.key)) {
          @for (styleGroup of collection.styleGroups; track styleGroup.key) {
            <div class="flex center hover grey padding-top-smallest padding-bottom-smallest padding-left" (click)="toggleNode(styleGroup.key)">
              <i class="fa-solid {{ isOpen(styleGroup.key) ? 'fa-angle-down' : 'fa-angle-right' }} small margin-right-small"></i>
              {{ styleGroup.label }}
            </div>

            @if (isOpen(styleGroup.key)) {
              @for (product of styleGroup.products; track product.style.modelId) {
                <div
                  class="flex center between hover radius padding-top-smallest padding-bottom-smallest padding-right-small padding-left-large {{
                    product.style.modelId === activeModelId ? 'bg-lightest-blue primary bold' : ''
                  }}"
                  (click)="selectProduct.emit(product)"
                >
                  <span class="truncate">{{ product.style.code }}</span>
                  <span class="small grey">{{ getShotsCount(product) }} shots</span>
                </div>
              }
            }
          }
        }
      }
    }
  } @empty {
    <span class="grey small">No products</span>
  }
</div>
